import { useState, useCallback } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Cities from './pages/Cities'
import RoutePlanner from './pages/RoutePlanner'
import FareCalculator from './pages/FareCalculator'
import MetroMap from './pages/MetroMap'
import Stations from './pages/Stations'
import StationDetails from './pages/StationDetails'
import TouristPlaces from './pages/TouristPlaces'
import NearbyHotels from './pages/NearbyHotels'
import NearbyBus from './pages/NearbyBus'
import SmartCard from './pages/SmartCard'
import About from './pages/About'
import { InterstitialAd } from './components/ads'
import { useInterstitialAd } from './hooks/useInterstitialAd'

function AppContent() {
  const [showInterstitial, setShowInterstitial] = useState(false)

  const handleShowAd = useCallback(() => {
    setShowInterstitial(true)
  }, [])

  const handleCloseAd = useCallback(() => {
    setShowInterstitial(false)
  }, [])

  // Hook to track navigation and trigger interstitial
  useInterstitialAd(handleShowAd)

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="cities" element={<Cities />} />
          <Route path="route" element={<RoutePlanner />} />
          <Route path="fare" element={<FareCalculator />} />
          <Route path="map" element={<MetroMap />} />
          <Route path="stations" element={<Stations />} />
          <Route path="station/:id" element={<StationDetails />} />
          <Route path="nearby/tourist" element={<TouristPlaces />} />
          <Route path="nearby/hotels" element={<NearbyHotels />} />
          <Route path="nearby/bus" element={<NearbyBus />} />
          <Route path="smart-card" element={<SmartCard />} />
          <Route path="about" element={<About />} />
        </Route>
      </Routes>
      <InterstitialAd isVisible={showInterstitial} onClose={handleCloseAd} />
    </>
  )
}

function App() {
  return <AppContent />
}

export default App
